import React from 'react';

interface ExpandButtonProps {
    text: string;
    onClick: () => void;
    icon?: React.ReactNode;
    className?: string;
}

const ExpandButton: React.FC<ExpandButtonProps> = ({ text, icon, onClick, className }) => {
    return (
        <button
            onClick={onClick}
            className={`flex items-center justify-center gap-2 px-4 py-2 text-sm rounded-md transition-all ${className}`}
        >
            {icon && <span>{icon}</span>}
            <span>{text}</span>
        </button>
    );
};

export default ExpandButton;
